<template>
  <div class="c-material-lifecycle">
    <div class="c-form">
      <ElForm inline label-width="50px" @submit.native.prevent class="elementui-common-form-styles" v-highlight>
        <ElFormItem label="游戏组">
          <el-select
            v-model="gameGroups"
            multiple
            collapse-tags
            filterable
            clearable
            placeholder="全部"
            value-key="id"
            @change="onGameGroupChange"
          >
            <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item"> </el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem label="标签">
          <el-select
            v-model="labelIds"
            multiple
            :multiple-limit="100"
            :popper-append-to-body="false"
            filterable
            collapse-tags
            clearable
            placeholder="请选择标签"
            style="width: 180px"
          >
            <el-option v-for="item in sysTagList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="标签组">
          <el-select v-model="tagGroups" filterable clearable multiple collapse-tags style="width: 180px" placeholder="全部">
            <el-option v-for="item in SYS_TAG_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="媒体">
          <el-select v-model="mediaId" clearable placeholder="全部" style="width: 160px">
            <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem label="营销主题标签" label-width="72">
          <el-select
            v-model="typeLabelIds"
            multiple
            clearable
            filterable
            collapse-tags
            placeholder="请选择营销主题标签"
            style="width: 180px"
            :popper-append-to-body="false"
          >
            <el-option v-for="item in marketingLabels" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </ElFormItem>

        <el-radio-group class="date-type-radio" v-model="dateType" @change="onDateTypeChange">
          <el-radio-button :label="DATE_TYPE.DAY">分日</el-radio-button>
          <el-radio-button :label="DATE_TYPE.WEEK">分周</el-radio-button>
          <el-radio-button :label="DATE_TYPE.MONTH">分月</el-radio-button>
          <el-radio-button :label="DATE_TYPE.TOTAL">汇总</el-radio-button>
        </el-radio-group>
        <div class="date-picker-wrapper">
          <DateRangePicker
            v-if="[DATE_TYPE.DAY, DATE_TYPE.TOTAL].includes(dateType)"
            v-model="datetime"
            style="width: 220px"
            :clearable="false"
            :pickerOptions="{ disabledDate }"
            @change="handleDatetime"
          ></DateRangePicker>
          <dateWeekRange
            v-if="dateType === DATE_TYPE.WEEK"
            v-model="weekRange"
            range-separator="至"
            style="width: 180px"
            start-placeholder="开始周"
            end-placeholder="结束周"
            :default-value="WeekDefaultShow"
            :picker-options="weekOptions"
            @change="handleDatetime"
            popper-class="week-range"
          >
          </dateWeekRange>
          <el-date-picker
            v-if="dateType === DATE_TYPE.MONTH"
            v-model="monthRange"
            type="monthrange"
            range-separator="至"
            style="width: 180px"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :default-value="MonthDefaultShow"
            :picker-options="monthOptions"
            @change="handleDatetime"
          >
          </el-date-picker>
        </div>
        <ElFormItem label-width="0" class="bg-transparent">
          <ElButton type="primary" @click="getData" style="vertical-align: top">查询</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="c-m-table">
      <Tabs v-model="platform" class="c-table-list">
        <TabPane name="0" label="全部"></TabPane>
        <TabPane name="1" label="Andriod"></TabPane>
        <TabPane name="2" label="iOS"></TabPane>
        <template slot="extra">
          <Button @click="modalColumn = true">自定义列</Button>
          &ensp;
          <Button :disabled="!tableList.length" icon="md-download" style="margin-right: 2px" @click="downData" :loading="exportLoading"
            >数据导出</Button
          >
        </template>
      </Tabs>

      <div class="c-scroll">
        <div class="c-compare-wrap">
          <template v-if="tableList.length">
            <div class="c-compare-form">
              <Select v-model="referEc" style="width: 180px">
                <Option v-for="drop in referEcDrop" :key="drop.key" :value="drop.key">{{ drop.title }}</Option>
              </Select>
            </div>
            <div class="c-echarts">
              <compare-echart :loading="loading" :compare-options="echartsOptions" />
            </div>
          </template>
          <Spin size="large" fix v-else-if="loading" />
          <div class="no-data" v-else>
            <Icon type="ios-filing-outline" size="58" color="#efefef" />
            <span>暂未选择标签</span>
          </div>
        </div>
        <lifecycle-table
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          :query-type="dateType"
          :filter-data="{ datetime, mediaId, tagGroups }"
          @sort-change="sortTable"
        />
        <Page
          show-total
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          show-sizer
          :page-size="pageSize"
          :page-size-opts="[15, 30, 50, 100]"
          @on-change="changePIndex"
          @on-page-size-change="changeSize"
        />
      </div>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="AnalysisMaterLifeCustomColumn"
      :data="rawTableCols"
      :sub-title="['报表数据', '创角留存', '创角LTV']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import moment from 'moment'
import { REPORT_LABEL_LIFECYCLE } from '@/views/download-center/data/const.js'
import { getLocal, setLocal, mul } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { toThousands, toPercentFixed, datetimeToDay } from '@/common/js/filters'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'

import mixinTable from './mixin_table'
import columns from '../data/material_label_life_column'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import CustomColumn from '@/components/converter/custom-column2.vue'
import CompareEchart from '@/components/echarts/echart.vue'
import LifecycleTable from './components/lifecycle-table.vue'

import { getLabelAnalysisData, initDownloadCenterTask } from '@/api/report.model'
import { initPageData, GAME_GROUPS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS } from '@/data/global-opts'
import { LABEL_TYPES } from '@/views/material/tags/const'

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS])
const DATE_TYPE = {
  HOUR: 0,
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
  TOTAL: 4
}

export default {
  name: 'labelAnalysisLifeCycle',
  mixins: [mixinTable],
  components: { CustomColumn, LifecycleTable, DateRangePicker, CompareEchart },
  computed: {
    ...PAGE_REQUIRED_OPTS,

    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    },
    referEcDrop() {
      return this.dropData.filter((ret) => ret.key)
    },
    marketingLabels() {
      return this.SYS_TAGS.filter((ret) => ret.labelType === LABEL_TYPES.MARKETING_LABEL)
    },
    /**
     * @description: 根据游戏组过滤标签
     */
    sysTagList() {
      // 过滤掉3d视频源标签 labelType === 2
      const tagData = this.SYS_TAGS.filter((tag) => tag.labelType === LABEL_TYPES.CONTENT_LABEL)
      if (!this.gameGroups?.length) return tagData

      // 如果选择了游戏组，过滤掉不属于游戏组的标签
      const data = tagData.filter((tag) => {
        if (!tag.gameIds) return false
        return this.selectedGameIds.some((id) => tag.gameIds.includes(id))
      })
      return data
    }
  },
  methods: {
    getData() {
      const [beginTime, endTime] = this.datetime || []
      let dates = { beginTime, endTime }

      if (this.dateType === DATE_TYPE.WEEK) {
        const [b, e] = this.weekRange.map((d) => moment(d).format('YYYY-MM-DD'))

        dates = { beginTime: b, endTime: e }
      }

      if (this.dateType === DATE_TYPE.MONTH) {
        const [b, e] = this.monthRange.map((d) => moment(d).format('YYYY-MM-DD'))
        dates = { beginTime: b, endTime: e }
      }
      const param = {
        ...dates,
        platform: this.platform,
        labelIds: this.labelIds.concat(this.typeLabelIds),
        mediaId: this.mediaId,
        dateType: this.dateType,
        labelGroupList: this.tagGroups,
        sort: this.sort,
        order: this.order
      }
      // if (this.loading) return
      this.loading = true
      getLabelAnalysisData(param).then((data) => {
        this.loading = false
        if (!data) return
        const { list, sumData } = data
        if (isArray(list) && sumData) {
          // 分日统计方式时，不显示新增关联素材数、总关联素材数
          if (this.dateType === DATE_TYPE.DAY) {
            this.sumData = { ...sumData, relatedMaterialsTotal: '-' }
          } else {
            this.sumData = sumData
          }
          this.listData = list
          this.tableList = this.calcTableData()
          this.total = list.length
          this.tableListLoaded = true
          this.creatEchart(this.referEc)
        }
      })
    },
    /**
     * @description: 切换游戏组时，根据游戏组筛选标签
     */
    onGameGroupChange(g) {
      this.labelIds = []
      this.selectedGameIds = g
        .map((item) => item.gameIds)
        .reduce((acc, curr) => {
          return acc.concat(curr)
        }, [])
    },
    onDateTypeChange(val) {
      switch (val) {
        case DATE_TYPE.WEEK:
          {
            // 默认周一到周天
            let monday = moment().weekday(0)
            let lastday = moment().weekday(6)
            // v4.22.1 如果今天是星期一，取上周一到上周天
            if (moment().day() === 1) {
              monday = moment().weekday(-7)
              lastday = moment().weekday(-1)
            }
            this.weekRange = [monday.format('YYYY-MM-DD'), lastday.format('YYYY-MM-DD')]
          }
          break

        case DATE_TYPE.MONTH:
          {
            // v4.22.1 例如今天是1月1日，则选中的是上月
            // 例如今天是1月2日，则选中的是本月
            let month = moment().format('YYYY-MM-01')
            const today = moment().format('YYYY-MM-DD')
            if (today.endsWith('-01')) {
              month = moment().subtract(1, 'month').format('YYYY-MM-DD')
            }
            this.monthRange = [month, month]
          }
          break

        default:
          break
      }
      this.pageIndex = 1
      this.getData()
    },
    calcTableData() {
      const start = (this.pageIndex - 1) * this.pageSize
      const end = this.pageSize * this.pageIndex
      return this.listData.slice(start, end)
    },
    creatEchart(refer, compare) {
      const ecKeys = [refer]
      const tableList = JSON.parse(JSON.stringify(this.listData))
      const legends = Array.from(new Set(tableList.map((ret) => ret.labelName)))

      // 如果dateType = 2 汇总统计，x轴只取一个点，就是统计的时间段，tableList[0].tdateDesc
      const xAxisData =
        this.dateType === DATE_TYPE.TOTAL
          ? [tableList[0].tdateDesc]
          : Array.from(new Set(tableList.sort((a, b) => a.tdate - b.tdate).map((ret) => ret.tdateDesc)))

      const yAxis = ecKeys.map((ret, i) => {
        const column = columns.filter((t) => t.key === ret).pop()
        let unit = ''
        if (ret.includes('Rate')) unit = '%'
        else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(ret)) unit = '元'
        return {
          name: column.title,
          nameGap: 5,
          type: 'value',
          axisLabel: {
            formatter: `{value} ${unit}`
          }
        }
      })
      const series = legends.map((met) => {
        return {
          name: met,
          data: tableList
            .filter((ret) => ret.labelName === met)
            .sort((a, b) => a.tdate - b.tdate)
            .map((ret) => (refer.includes('Rate') ? mul(100, ret[refer]) : ret[refer])),
          type: 'line'
        }
      })

      // 图表配置
      this.echartsOptions = {
        legend: {
          height: 30,
          bottom: 0,
          itemWidth: 12,
          itemHeight: 6,
          align: 'right',
          data: legends,
          textStyle: {
            lineHeight: 4
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          padding: 10,
          confine: true,
          formatter: (params) => {
            let total = 0
            legends.map((ret, i) => {
              total += params[i].value
            })
            const tooltips = legends.map((ret, i) => {
              let unit = ''
              let percent = 0
              if (total) {
                let val = params[i].value / total
                if (val > 0 && val < 1) {
                  const t = val.toString().split('.')
                  if (t[1] && t[1].length > 4) val = parseFloat(val.toFixed(4))
                }
                percent = mul(val, 100)
              }
              if (refer.includes('Rate')) unit = '%'
              else if (['paperUseAmount', 'amount', 'activeCost', 'createRoleCost', 'sumRecharge', 'sumMoney'].includes(refer)) unit = '元'
              const percentShow = ['paperUseAmount', 'amount', 'downNum', 'newUserNum', 'createRoleNum', 'newRoleNum'].includes(refer)
              const percentHtml = percentShow ? `<span>占比：${percent}%</span>` : ''
              return `<dd class="tooltop-span"><span style="background-color: ${params[i].color}"></span>${params[i].seriesName}: ${params[i].value} ${unit} ${percentHtml}</dd>`
            })
            let formatHtml = `<h3 class="tooltip-h3">${params[0].name}</h3>`
            formatHtml += tooltips.join('')
            return formatHtml
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: !0,
            position: 'bottom',
            offset: 0,
            data: xAxisData
          }
        ],
        yAxis,
        series,
        grid: { top: 35, left: 16, right: 16, bottom: 34, containLabel: !0 }
      }
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumData))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const numbers = [
          'pv',
          'clickNum',
          'paperUseAmount',
          'amount',
          'newRoleMoney',
          'sumRecharge',
          'sumMoney',
          'downNum',
          'newUserNum',
          'createRoleNum',
          'newRoleNum',
          'payRoleUserNum',
          'timeDiff'
        ]
        const rates = [
          'createRoleRate',
          'payRoleUserRate',
          'newRoleRate1d',
          'newRoleRate',
          'sumRebateRate',
          'twoDayCreateRetain',
          'threeDayCreateRetain',
          'fourDayCreateRetain',
          'fiveDayCreateRetain',
          'sixDayCreateRetain',
          'sevenDayCreateRetain',
          'tenDayCreateRetain',
          'fifteenDayCreateRetain',
          'thirtyDayCreateRetain',
          'createRoleRoi1d',
          'createRoleRoi3d',
          'createRoleRoi7d'
        ]
        // 格式化数据格式
        if (numbers.includes(prop)) sums[index] = toThousands(data[prop])
        else if (rates.includes(prop)) sums[index] = toPercentFixed(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleMedia(meta) {
      this.mediaId = meta.id
    },
    handleDatetime(dates) {
      const [start, end] = dates || []
      if (!start || !end) return
      // const limitDate = moment(end).subtract(90, 'days')

      // if (limitDate.isAfter(start)) {
      //   this.$Message.warning('日期范围不能超过90天！')
      //   const newDate = limitDate.format('YYYY-MM-DD')
      //   this.datetime = [newDate, end]
      // }

      if (this.labelIds.length) {
        this.pageIndex = 1
        this.getData()
      }
    },
    changeSize(size) {
      this.pageSize = size
      this.tableList = this.calcTableData()
    },
    changePIndex(index) {
      this.pageIndex = index
      this.tableList = this.calcTableData()
    },
    downData() {
      const [beginTime, endTime] = this.datetime || []
      let dates = { beginTime, endTime }

      if (this.dateType === DATE_TYPE.WEEK) {
        const [b, e] = this.weekRange.map((d) => moment(d).format('YYYY-MM-DD'))

        dates = { beginTime: b, endTime: e }
      }

      if (this.dateType === DATE_TYPE.MONTH) {
        const [b, e] = this.monthRange.map((d) => moment(d).format('YYYY-MM-DD'))
        dates = { beginTime: b, endTime: e }
      }
      const exportColumnOrderMap = {}
      this.tableColumns.forEach((col) => {
        if (col.checked && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })

      const params = {
        ...dates,
        sessionid: this.$store.state.token,
        platform: this.platform,
        labelIds: this.labelIds.concat(this.typeLabelIds),
        labelGroupList: this.tagGroups,
        dateType: this.dateType,
        mediaId: this.mediaId,
        exportColumnOrderMap
      }

      this.order && (params.order = this.order)
      this.sort && (params.sort = this.sort)

      const conditionText = transferTaskQueryConditions.call(this, { ...params }, REPORT_LABEL_LIFECYCLE)
      this.exportLoading = true
      initDownloadCenterTask({
        pageType: REPORT_LABEL_LIFECYCLE,
        queryCondition: { ...params, conditionText }
      }).then((data) => {
        this.exportLoading = false
        if (data.msg) {
          this.$Message.success(data.msg)
          this.$store.commit('setDownloadBadgeActive', 1)
        }
      })
    },
    proLoadData() {
      // 渲染EC对比下拉框
      this.referEc = 'amount'
    },
    onTableColsChange(cols) {
      this.modalColumn = false
      this.tableColumns = cols
    },
    headerDragend({ n, o, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    disabledDate(date) {
      return date && date.valueOf() > Date.now()
    },
    initRouteQueryParams() {
      const { name, query } = this.$route
      if (name === 'labelAnalysisLifeCycle') {
        const { labelGroupId } = query
        if (labelGroupId) {
          this.tagGroups = [Number(labelGroupId)]
          this.getData()
        }
      }
    }
  },
  data() {
    return {
      DATE_TYPE,
      tableColumns: [],
      rawTableCols: columns,
      pageSize: 15,
      // tableListLoaded作为是否请求数据的标记，表格因为请求数据时间间隔，会导致显示问题，等待数据请求完后再计算表格高度进行表格渲染
      tableListLoaded: false,
      tableHeight: 230,
      selectedGameIds: [], // 保存查询列表已选的游戏组的游戏id，通过结果筛选标签
      dateType: 1, // 统计方式  1 分日  2 汇总
      platform: '0',
      mediaId: '',
      typeLabelIds: [],
      sysTagData: [],
      labelIds: [],
      gameGroups: [], // 游戏组
      tagGroups: [], // 标签组
      tableList: [], // 表格数据
      listData: [], // 所有数据
      sumData: [], // 统计数据
      dropData: [], // 对比下拉数据
      referEc: '',
      echartsOptions: {},
      datetime: [],
      weekRange: [],
      monthRange: [],
      exportLoading: false,
      WeekDefaultShow: '',
      MonthDefaultShow: '',
      weekOptions: {
        firstDayOfWeek: 1,
        cellClassName: (date) => {
          if (date && date.valueOf() > Date.now()) return 'empty-date'
          return ''
        },
        disabledDate: (date) => {
          const isMonday = new Date().getDay() === 1
          if (isMonday) {
            return date && date.valueOf() > Date.now()
          }
          return date && date.valueOf() > Date.now() + (7 - new Date().getDay()) * 1000 * 60 * 60 * 24
        }
      },
      monthOptions: {
        disabledDate: this.disabledDate
      }
    }
  },
  watch: {
    platform(nVal) {
      this.pageIndex = 1
      this.labelIds.length && this.getData()
    },
    referEc(nVal) {
      this.creatEchart(nVal)
    },
    '$route.query'() {
      this.initRouteQueryParams()
    }
  },
  mounted() {
    this.WeekDefaultShow = new Date()
    this.MonthDefaultShow = new Date()
    this.WeekDefaultShow.setMonth(new Date().getMonth() - 1)
    this.MonthDefaultShow.setFullYear(new Date().getFullYear() - 1)
  },
  created() {
    const dropData = JSON.parse(JSON.stringify(columns))
    dropData.shift()
    dropData.shift()
    const beginTime = moment().format('YYYY-MM-DD')
    const endTime = moment().format('YYYY-MM-DD')
    this.datetime = [beginTime, endTime]
    this.dropData = dropData

    this.proLoadData()
    const { query } = this.$route
    if (Object.keys(query).length) {
      this.initRouteQueryParams()
    } else {
      // this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.c-material-lifecycle {
  position: relative;
  padding-top: 10px;

  .c-m-table {
    ::v-deep .ivu-btn:hover {
      background-color: transparent;
    }

    .c-table-list {
      height: 44px;

      .c-pane {
        height: 100%;
      }
    }

    .c-compare-wrap {
      position: relative;
      height: 350px;
      margin-bottom: 12px;
      padding: 0 12px 0;
      background-color: #fff;

      .c-compare-form {
        width: 420px;
        height: 48px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-bottom: 8px;
      }

      .c-echarts {
        height: calc(100% - 48px);
      }
    }

    .c-show-switch {
      height: 32px;
      display: inline-flex;
      align-items: center;
      padding: 0 10px 0 5px;

      span {
        padding: 0 8px;
      }
    }
  }

  .c-table-page {
    padding: 0 8px;
    margin-top: 7px;
    text-align: right;
  }

  .no-data {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span {
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss">
.g-main-wrapper {
  height: unset;
  min-height: 100%;
  padding-bottom: 8px;
}
.g-wrapper {
  overflow: hidden;
}
.c-scroll {
  overflow-y: auto;
  height: calc(100vh - 64px - 50px - 140px);
}
.date-type-radio {
  margin-right: 5px;
  margin-bottom: 8px !important;
}
.date-picker-wrapper {
  display: inline-block;
  margin-bottom: 8px !important;
  vertical-align: top;
}
</style>
